import { render } from "./EventItemShort.vue?vue&type=template&id=d67d558a&ts=true"
import script from "./EventItemShort.vue?vue&type=script&lang=ts"
export * from "./EventItemShort.vue?vue&type=script&lang=ts"

import "./EventItemShort.vue?vue&type=style&index=0&id=d67d558a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__